var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1041,
    viewBox: "0 0 1440 1041",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_4972_4569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1232.17 34.5392C1432.91 12.9225 1421.92 58.8259 1538.03 146.706C1582.16 180.111 1511.95 215.039 1449.19 271.792C1422.91 295.554 1096.32 296.12 992.823 273.371C666.441 201.631 869.254 187.207 865.023 162.899C860.792 138.591 1031.42 56.1558 1232.17 34.5392Z",
    fill: "#FF6436"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4972_4569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M911.64 -128.84C1205.95 -143.39 1182.23 -102.771 1335.36 -21.7991C1393.56 8.98023 1285.97 38.4386 1185.44 87.5063C1143.34 108.051 670.431 100.91 524.465 78.2297C64.1552 6.70773 360.236 -1.38935 358.249 -23.1337C356.262 -44.8781 617.327 -114.29 911.64 -128.84Z",
    fill: "#0047FF",
    fillOpacity: 0.3,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4972_4569",
    x: 56.6011,
    y: -720.761,
    width: 2245.25,
    height: 1760.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 375,
    result: "effect1_foregroundBlur_4972_4569"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4972_4569",
    x: -83.6587,
    y: -481.753,
    width: 1785.43,
    height: 931.405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_4972_4569"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.f549846ae6769497c230501dd0683f5f.svg";
export { ForwardRef as ReactComponent };